<template>
    <div>
        <h3 class="font-bold text-base mb-4">
            Kontaktinformasjon
        </h3>
        <div class="flex flex-row items-start mb-4">
            <div class="pr-2">
                <font-awesome-icon class="fa-lg" icon="building" />
            </div>
            <div class="flex flex-col">
                <div>{{model.footer.organizationName}}</div>
                <div>{{model.footer.address}}</div>
                <div>{{model.footer.zipAndCity}}</div>
            </div>
        </div>

        <div class="flex flex-row items-start mb-4">
            <div class="pr-2">
                <font-awesome-icon class="fa-lg" icon="phone-alt" />
            </div>
            <div class="flex flex-col">
                <a :href="model.footer.phone.href" class="underline hover:text-green-400">{{model.footer.phone.text}}</a>
            </div>
        </div>

        <div class="flex flex-row items-start mb-4">
            <div class="pr-2">
                <font-awesome-icon class="fa-lg" icon="envelope" />
            </div>
            <div class="flex flex-col">
                <a :href="model.footer.email.href" class="underline hover:text-green-400">{{model.footer.email.text}}</a>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: ['model']
};
</script>
